export default __webpack_public_path__ + "static/media/03.503840fe.png";